import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header, { BreadcrumbItem } from '../components/Header';
import { usePageTracking } from '../hooks/usePageTracking';
import styles from '../styles/findMeetingsPage.module.css';

interface FindMeetingsPageProps {
  user?: any;
  onLogout: () => void;
  onLogin: () => void;
}

const FindMeetingsPage: React.FC<FindMeetingsPageProps> = ({ user, onLogout, onLogin }) => {
  const navigate = useNavigate();
  const [code, setCode] = useState('');

  usePageTracking('Find a Meeting');

  const breadcrumbs: BreadcrumbItem[] = [
    { label: 'Home', path: '/', active: false },
    { label: 'Find a meeting', path: '/meetings', active: true }
  ];

  const handleGo = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = code.trim().toUpperCase();
    if (!trimmed) return;
    navigate(`/meetings/${encodeURIComponent(trimmed)}`);
  };

  return (
    <div className={styles.findMeetingsPage}>
      <Header breadcrumbs={breadcrumbs} user={user} onLogout={onLogout} onLogin={onLogin} />
      <main className={styles.mainContent}>
        <div className={styles.hero}>
          <h1 className={styles.title}>Find a meeting</h1>
        </div>

        <section className={styles.browseSection}>
          <h2 className={styles.browseTitle}>Browse meetings by program</h2>
          <div className={styles.programLinks}>
            <a href="/saa?tab=meetings" className={styles.programLink}>
              SAA meetings
            </a>
            <span className={styles.moreComing}>More programs coming soon</span>
          </div>
        </section>

        <section className={styles.codeSection}>
          <p className={styles.codeIntro}>Have a meeting code?</p>
          <form onSubmit={handleGo} className={styles.codeForm}>
            <div className={styles.codeRow}>
              <input
                id="meeting-code"
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="e.g. AA14 or SAA9"
                className={styles.codeInput}
                autoComplete="off"
              />
              <button type="submit" className={styles.goButton}>
                Go
              </button>
            </div>
            <p className={styles.codeHint}>Ask your meeting leader for the code</p>
          </form>
        </section>

        {!user && (
          <p className={styles.signInPrompt}>
            New here? <button type="button" onClick={onLogin} className={styles.signInLink}>
              Sign in
            </button>{' '}
            or create an account to add yourself to a meeting.
          </p>
        )}
      </main>
    </div>
  );
};

export default FindMeetingsPage;
